import { ShiftTime } from './oeeshift.model'


export default class ShiftService {
    fetchsettings(): Promise<ShiftTime[]> {
        return fetch('api/OeeSettings/listShift')
            .then(response => response.json() as Promise<ShiftTime[]>);
    };

    /**
     * Posts an ShiftTime to the server
     * @param ShiftTime
     */
    postsetting(oeeshift: ShiftTime): Promise<any> {
        return fetch('api/OeeSettings/addOeeShift',
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(oeeshift)
            })
            .then(response => response.status);
    };

    /**
     * Updates an ShiftTime to the server
     * @param OeeSettings
     */
    updatesetting(oeesettings: ShiftTime): Promise<any> {
        return fetch('api/OeeSettings/updateOeeShift',
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(oeesettings)
            })
            .then(response => response.status);
    };


    /**
     * Posts an deletion request
     * @param OeeSetings
     */
    deletesettings(oeeshift: ShiftTime[]): Promise<any>
    {
        return fetch('api/OeeSettings/deleteOeeShift',
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(oeeshift)
            })
            .then(response => response.status);
    };

}